/*!
 * Bootstrap Show Password Toggle v1.4.1
 * Copyright 2020-2023 C.Oliff
 * Licensed under MIT (https://github.com/coliff/bootstrap-show-password-toggle/blob/main/LICENSE)
 */

var ShowPasswordToggle = document.querySelector("[type='password']");
if (ShowPasswordToggle) {
  // ShowPasswordToggle.onclick = function () {
  //   ShowPasswordToggle.classList.add("input-password");
  //   document.getElementById("toggle-password").classList.remove("d-none");

  //   const passwordInput = ShowPasswordToggle;
  //   const togglePasswordButton = document.getElementById("toggle-password");

  //   togglePasswordButton.addEventListener("click", togglePassword);

  //   function togglePassword() {
  //     if (passwordInput.type === "password") {
  //       passwordInput.type = "text";
  //       togglePasswordButton.setAttribute(
  //         "aria-label",
  //         "Hide password."
  //       );

  //       console.log(1);
  //       console.log(passwordInput.type);
  //     } else {
  //       passwordInput.type = "password";
  //       togglePasswordButton.setAttribute(
  //         "aria-label",
  //         "Show password as plain text. Warning: this will display your password on the screen.",
  //       );

  //       console.log(2);
  //       console.log(passwordInput.type);
  //     }
  //   }
  // };

  ShowPasswordToggle.onfocus = function () {
    ShowPasswordToggle.classList.add("input-password");
    document.getElementById("toggle-password").classList.remove("d-none");

    const passwordInput = ShowPasswordToggle;
    const togglePasswordButton = document.getElementById("toggle-password");

    togglePasswordButton.addEventListener("click", togglePassword);

    function togglePassword(e) {
      if (passwordInput.type === "password") {
        passwordInput.type = "text";
        togglePasswordButton.setAttribute(
          "aria-label",
          "Hide password."
        );

        // console.log(3);
        // console.log(passwordInput.type);
        // console.log(e);
        e.preventDefault();
      } else {
        passwordInput.type = "password";
        togglePasswordButton.setAttribute(
          "aria-label",
          "Show password as plain text. Warning: this will display your password on the screen.",
        );

        // console.log(4);
        // console.log(passwordInput.type);
        // console.log(e);
        e.preventDefault();
      }
    }
  };
}
